import { Vue, newVue } from '@/config/vue'

On.VueInit({
  controller: 'orders',
  action: 'edit',
  init() {
    const selector = '.js-vue-checkout-cart-buttons'
    if (!document.querySelector(selector)) {
      return
    }
    const CartCheckoutButtons = Vue.component('cart-buttons', () =>
      import(/* webpackChunkName: "cart-buttons" */ './Cart/CheckoutButtons.vue')
    )
    newVue({
      render: h => h(CartCheckoutButtons),
      mount: selector,
      stores: ['checkout'],
    })
  },
})

On.VueInit({
  controller: 'checkout',
  action: 'registration',
  init() {
    const selector = '.js-vue-checkout-registration'
    if (!document.querySelector(selector)) {
      return
    }
    const Registration = Vue.component('registration', () =>
      import(/* webpackChunkName: "checkout-registration" */ './Registration/Registration.vue')
    )
    newVue({
      render: h => h(Registration),
      mount: selector,
    })
  },
})

On.VueInit({
  controller: 'checkout',
  action: 'edit',
  init() {
    const selector = '.js-vue-checkout-address'
    if (!document.querySelector(selector)) {
      return
    }
    const Address = Vue.component('checkout-address', () =>
      import(/* webpackChunkName: "checkout-address" */ './Address/Address.vue')
    )
    newVue({
      render: h => h(Address),
      mount: selector,
      stores: ['checkout', 'territories'],
    })
  },
})

On.VueInit({
  controller: 'checkout',
  action: 'edit',
  init() {
    const selector = '.js-vue-checkout-cards-payment'
    if (!document.querySelector(selector)) {
      return
    }
    const CardsPayment = Vue.component('cards-payment', () =>
      import(/* webpackChunkName: "cards-payment" */ './Payment/Cards/Payment.vue')
    )
    newVue({
      render: h => h(CardsPayment),
      mount: selector,
      stores: ['checkout'],
    })
  },
})

On.VueInit({
  controller: 'checkout',
  action: 'edit',
  init() {
    const selector = '.js-vue-checkout-applepay-payment'
    if (!document.querySelector(selector)) {
      return
    }
    const ApplePayPaymentCheckout = Vue.component('apple-pay', () =>
      import(/* webpackChunkName: "apple-pay" */ './Payment/ApplePay/PaymentCheckout.vue')
    )
    newVue({
      render: h => h(ApplePayPaymentCheckout),
      mount: selector,
      stores: ['checkout'],
    })
  },
})
